import {
  Checkbox as MantineCheckbox,
  CheckboxGroupProps,
  CheckboxProps,
} from '@mantine/core';
import {FieldAdapter} from '../field-factory';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $CheckboxGroupAdapterProps = CheckboxGroupProps;

export const $CheckboxGroupAdapter: FC<
  FieldAdapter<$CheckboxGroupAdapterProps>
> = ({inputProps: {onChange, ...inputProps}, control}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: CheckboxGroupProps['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineCheckbox.Group
      error={invalid}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};

export const $CheckboxGroupItemAdapter = ({
  disabled,
  ...props
}: CheckboxProps) => {
  const {readOnly} = useContext(ReadOnlyContext);
  return <MantineCheckbox disabled={disabled || readOnly} {...props} />;
};